if (!customElements.get('tyga-hero-film')) {
  customElements.define('tyga-hero-film', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button || this.bound) return;
      this.bound = true;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.manualPause = false;
      this.visible = false;
      this.button.hidden = false;
      this.onClick = () => {
        if (!this.video.paused) { this.manualPause = true; this.video.pause(); }
        else { this.manualPause = false; this.play(); }
      };
      this.onPlay = () => { this.dataset.playing = 'true'; this.dataset.loaded = 'true'; this.button.textContent = 'Pause film'; };
      this.onPause = () => { this.dataset.playing = 'false'; this.button.textContent = 'Play film'; };
      this.onVisibility = () => { if (document.hidden) this.video.pause(); else this.autoPlay(); };
      this.onMotion = () => { if (this.motion.matches) { this.video.pause(); this.dataset.loaded = 'false'; } else this.autoPlay(); };
      this.button.addEventListener('click', this.onClick);
      this.video.addEventListener('playing', this.onPlay);
      this.video.addEventListener('pause', this.onPause);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.motion.addEventListener('change', this.onMotion);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.autoPlay(); else this.video.pause();
      }, {threshold: 0.15});
      this.observer.observe(this);
    }
    autoPlay() {
      if (this.visible && !document.hidden && !this.manualPause && !this.motion.matches && !navigator.connection?.saveData) this.play();
    }
    play() {
      if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
      this.video.muted = true;
      this.video.play().catch(() => { this.button.textContent = 'Play film'; });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.motion?.removeEventListener('change', this.onMotion);
      this.button?.removeEventListener('click', this.onClick);
      this.video?.removeEventListener('playing', this.onPlay);
      this.video?.removeEventListener('pause', this.onPause);
      this.bound = false;
    }
  });
}
